<template>

  <Head title="Posisi" />
  <div class="card card-outline card-primary">
    <div class="card-header">
      <h3 class="card-title">UBAH POSISI</h3>
      <div class="card-tools">
        <Link href="/role" class="btn btn-tool"><i class="fas fa-times"></i></Link>
      </div>
    </div>
    <form @submit.prevent="submit">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <input-text label="Posisi" v-model="form.name" :error="form.errors.name"/>
          </div>
          <div class="col-sm-8">
            <div>
              <label>Hak Akses</label> &nbsp;&nbsp;
              <span v-if="form.errors.permission" style="color:#dc3545; font-size:80%">{{
                form.errors.permission
              }}</span>
              <div class="row">
                <div v-for="permission in permissions" :key="permission.name">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" :id="permission.name" v-model="form.permission"
                      :value="permission.name">
                    <label class="custom-control-label" :for="permission.name">{{ permission.name }}</label>
                    &nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="submit" class="btn btn-primary mr-2" :disabled="form.processing">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from '@inertiajs/vue3'
import InputText from '@/Forms/InputText'

export default {
  layout: Layout,
  components: {
    Head,
    Link,
    InputText,
  },
  props: {
    role: Object,
    akses: Array,
    permissions: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.role.name,
        permission: (this.akses.length === 0) ? [] : this.akses,
      }),
    }
  },
  methods: {
    submit() {
      this.form.patch('/role/' + this.role.id, {
        preserveScroll: true,
        onSuccess: page => {
          toastr.success('Ubah Posisi berhasil', 'SUKSES')
        },
        onError: errors => {
          toastr.error('Ubah Posisi gagal', 'GAGAL')
        },
      })
    },
  },
}
</script>